import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '@app/services/main.service';
import { UsersService } from '@app/services/users.service';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-dialog',
    templateUrl: './verify-phone-dialog.component.html',
    styleUrls: ['./verify-phone-dialog.component.scss'],
    imports: [MatDialogModule, MatButtonModule, FormsModule, MatFormFieldModule, MatInputModule],
})
export class VerifyPhoneDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<VerifyPhoneDialogComponent>>(MatDialogRef);

    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    public readonly mainService = inject(MainService);
    public readonly usersService = inject(UsersService);

    public phone: string;
    public code: string;

    constructor() {
        const data = inject(MAT_DIALOG_DATA);

        this.phone = data.phone;
        this.code = data.code;
    }

    public get isVerified(): boolean {
        return this.usersService.user.contact?.phone[0].isVerified;
    }

    public ngOnInit(): void {
        this.usersService.patchUserContact(this.usersService.user?._id, {
            contactId: this.usersService.user?.contactId,
            contact: { 'contacts.phoneVerification': true },
        });
    }

    public verify() {
        if (this.code) {
            if (this.usersService.user?.contact?.phoneVerificationCode?.toString() === this.code.toString()) {
                this.mainService.verifiedHere = true;
                this.usersService.user.contact.phone[0].isVerified = true;
                this.usersService.patchUserContact(this.usersService.user?._id, {
                    contactId: this.usersService.user?.contactId,
                    contact: { 'contacts.phoneVerified': true, 'contacts.phoneVerificationCode': null },
                });
            }
        }
    }

    public close() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            queryParamsHandling: '',
        });
    }
}
